// extracted by mini-css-extract-plugin
export var container = "Panels-module--container--ccc4a";
export var header = "Panels-module--header--230fb";
export var headerLeft = "Panels-module--header-left--d215c";
export var headerRight = "Panels-module--header-right--1627e";
export var left = "Panels-module--left--1bead";
export var overlay = "Panels-module--overlay--2822a";
export var right = "Panels-module--right--7e973";